(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-countdown"] && !Shopify.designMode) return;
  try {
    
(function(){
  function start(root){
    if(!root || root.dataset.poReady) return;
    root.dataset.poReady = '1';
    var target = Date.parse(root.dataset.kickoff || '');
    if(isNaN(target)) return;
    var done = root.dataset.done || '';
    var title = root.querySelector('.po-dtitle');
    var f = { d:root.querySelector('[data-u="d"]'), h:root.querySelector('[data-u="h"]'),
              m:root.querySelector('[data-u="m"]'), s:root.querySelector('[data-u="s"]') };
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var left = Math.max(0, Math.floor((target - Date.now())/1000));
      var d = Math.floor(left/86400); left -= d*86400;
      var h = Math.floor(left/3600);  left -= h*3600;
      var m = Math.floor(left/60);
      var s = left - m*60;
      if(f.d) f.d.textContent = pad(d);
      if(f.h) f.h.textContent = pad(h);
      if(f.m) f.m.textContent = pad(m);
      if(f.s) f.s.textContent = pad(s);
      if(target - Date.now() <= 0 && done && title){ title.textContent = done; }
    }
    tick(); setInterval(tick, 1000);
  }
  function boot(){ document.querySelectorAll('.po-drop').forEach(start); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-occupation"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.poReady) return;
    root.dataset.poReady='1';
    var wrap=root.querySelector('.po-jobwrap');
    var jobs=(root.getAttribute('data-jobs')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
    if(!wrap||!jobs.length) return;
    var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i=0,cur=document.createElement('b');
    cur.textContent=jobs[0];cur.className='in';wrap.appendChild(cur);
    if(reduce||jobs.length<2){cur.style.opacity=1;cur.style.transform='none';return;}
    var running=true;
    if('IntersectionObserver' in window){
      running=false;
      new IntersectionObserver(function(es){running=es[0].isIntersecting;},{threshold:.2}).observe(root);
    }
    setInterval(function(){
      if(!running)return;
      var old=cur;old.className='out';
      i=(i+1)%jobs.length;
      cur=document.createElement('b');cur.textContent=jobs[i];cur.className='in';
      wrap.appendChild(cur);
      setTimeout(function(){if(old.parentNode)old.parentNode.removeChild(old);},360);
    },1800);
  }
  function boot(){document.querySelectorAll('.po-occ').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-script-ohio"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.poReady) return;
    root.dataset.poReady = '1';
    if(!matchMedia('(hover: hover) and (pointer: fine)').matches && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ e.target.classList.toggle('act', e.intersectionRatio > .55); });
      }, { threshold:[0,.55,1] });
      root.querySelectorAll('.po-fantee').forEach(function(t){ io.observe(t); });
    }
  }
  function boot(){ document.querySelectorAll('.po-script').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-tickers"] && !Shopify.designMode) return;
  try {
    
(function(){
  var API = 'https://site.api.espn.com/apis/site/v2/sports/';
  var DEBUG = false;
  var TZ = 'America/New_York';
  var TZLABEL = 'ET';
  function log(){ if(DEBUG && window.console) console.log.apply(console, ['[PO ticker]'].concat([].slice.call(arguments))); }

  var CLUBS = {
    REDS:    { colour:'#C6011F', href:'/collections/cincinnati-baseball-1', path:'baseball/mlb', abbr:'CIN', id:'17' },
    GUARDS:  { colour:'#0C2340', href:'/collections/baseball', path:'baseball/mlb', abbr:'CLE', id:'5' },
    CAVS:    { colour:'#860038', href:'/collections/cleveland-basketball', path:'basketball/nba', abbr:'CLE', id:'5' },
    BROWNS:  { colour:'#3B2314', href:'/collections/cleveland-football', path:'football/nfl', abbr:'CLE', id:'5' },
    BENGALS: { colour:'#FB4F14', href:'/collections/cincinnati', path:'football/nfl', abbr:'CIN', id:'4' },
    BUCKEYES:{ colour:'#BB0000', href:'/collections/columbus-football', path:'football/college-football', abbr:'OSU', id:'194' }
  };

  var CURRENT_CLUBS = ['REDS','GUARDS'];
  var UPCOMING_CLUBS = ['BROWNS','BENGALS','BUCKEYES'];

  var FALLBACK_NOW = [
    {t:'REDS',l:'CIN 10 \u2014 PIT 2',r:'W',w:'Final \u00b7 Aug 2'},
    {t:'REDS',l:'vs Athletics',r:'NEXT',w:'Tue Aug 4 \u00b7 6:40p ET'},
    {t:'GUARDS',l:'CLE 5 \u2014 ARI 0',r:'W',w:'Final \u00b7 Aug 2'},
    {t:'GUARDS',l:'vs Mets',r:'NEXT',w:'Tue Aug 4 \u00b7 6:40p ET'},
    {t:'REDS',l:'CIN 1 \u2014 PIT 4',r:'L',w:'Final \u00b7 Aug 1'},
    {t:'GUARDS',l:'CLE 8 \u2014 ARI 12',r:'L',w:'Final \u00b7 Aug 1'}
  ];
  var FALLBACK_NEXT = [
    {t:'BENGALS',l:'vs Lions',w:'Thu Aug 13 \u00b7 Preseason'},
    {t:'BROWNS',l:'at Bears',w:'Sat Aug 15 \u00b7 Preseason'},
    {t:'BENGALS',l:'vs Bears',w:'Sat Aug 22 \u00b7 Preseason'},
    {t:'BROWNS',l:'vs Bills',w:'Sat Aug 22 \u00b7 Preseason'},
    {t:'BUCKEYES',l:'vs Ball State',w:'Sat Sep 5 \u00b7 12:30p ET'},
    {t:'BUCKEYES',l:'at Texas',w:'Sat Sep 12 \u00b7 7:30p ET'}
  ];

  /* Every date is rendered in the league's home timezone (Eastern), not the
     visitor's. A shopper in Ohio and a shopper in Manila see the same thing. */
  function fmt(d, opts){
    var o = { timeZone: TZ };
    for(var k in opts){ if(opts.hasOwnProperty(k)) o[k] = opts[k]; }
    try { return d.toLocaleString('en-US', o); }
    catch(e){ return d.toLocaleString('en-US', opts); }
  }

  function dayLabel(d){
    return fmt(d, { weekday:'short', month:'short', day:'numeric' }).replace(/,/g, '');
  }
  function shortDate(d){
    return fmt(d, { month:'short', day:'numeric' }).replace(/,/g, '');
  }
  function timeLabel(d){
    var t = fmt(d, { hour:'numeric', minute:'2-digit', hour12:true });
    t = t.replace(/\s?AM/i, 'a').replace(/\s?PM/i, 'p').replace(/:00([ap])$/, '$1');
    return t + ' ' + TZLABEL;
  }
  function when(d, withTime){
    return withTime ? dayLabel(d) + ' \u00b7 ' + timeLabel(d) : dayLabel(d);
  }

  function card(g){
    var club = CLUBS[g.t] || {};
    var cls = g.r === 'W' ? 'w' : (g.r === 'L' ? 'l' : (g.r === 'LIVE' ? 'live' : 'n'));
    var badge = g.r ? '<span class="po-res ' + cls + '">' + g.r + '</span>' : '';
    return '<a class="po-g" href="' + (club.href || '/collections/all') + '">' +
           '<span class="po-club" style="background:' + (club.colour || '#33302C') + '">' + g.t + '</span>' +
           '<span class="po-ln">' + g.l + '</span>' + badge +
           '<span class="po-wh">' + g.w + '</span></a>';
  }

  function paint(rail, list){
    if(!rail || !list || !list.length) return;
    var html = list.map(card).join('');
    rail.innerHTML = html + html;
  }

  function getJSON(url){
    return fetch(url, { mode:'cors', credentials:'omit' }).then(function(r){
      if(!r.ok) throw new Error(r.status + ' ' + url);
      return r.json();
    });
  }

  function lookupId(club){
    return getJSON(API + club.path + '/teams?limit=400').then(function(j){
      var leagues = ((j.sports || [])[0] || {}).leagues || [];
      var teams = (leagues[0] || {}).teams || [];
      for(var i = 0; i < teams.length; i++){
        var t = teams[i].team || {};
        if((t.abbreviation || '').toUpperCase() === club.abbr) return t.id;
      }
      return null;
    });
  }

  function num(s){
    if(s == null) return NaN;
    if(typeof s === 'object') s = (s.value != null ? s.value : s.displayValue);
    return parseInt(s, 10);
  }

  function readEvent(ev, key){
    var comp = (ev.competitions || [])[0] || ev;
    var cs = comp.competitors || [];
    if(cs.length < 2) return null;
    var abbr = CLUBS[key].abbr, me = null, them = null;
    for(var i = 0; i < cs.length; i++){
      var a = (((cs[i].team || {}).abbreviation) || '').toUpperCase();
      if(a === abbr && !me) me = cs[i]; else them = cs[i];
    }
    if(!me || !them) return null;
    var st = ((comp.status || ev.status || {}).type) || {};
    var d = new Date(ev.date || comp.date);
    if(isNaN(d.getTime())) return null;
    var home = me.homeAway === 'home';
    var themTeam = them.team || {};
    var themName = themTeam.shortDisplayName || themTeam.name || themTeam.abbreviation || 'TBD';

    if(st.completed === true){
      var mine = num(me.score), theirs = num(them.score);
      if(isNaN(mine) || isNaN(theirs)) return null;
      return { t:key, done:true, date:d,
        l: abbr + ' ' + mine + ' \u2014 ' + (themTeam.abbreviation || '?') + ' ' + theirs,
        r: mine > theirs ? 'W' : 'L',
        w: 'Final \u00b7 ' + shortDate(d) };
    }
    if(st.state === 'in'){
      return { t:key, live:true, date:d, l:(home ? 'vs ' : 'at ') + themName, r:'LIVE', w: st.shortDetail || 'In progress' };
    }
    return { t:key, date:d, l:(home ? 'vs ' : 'at ') + themName, r:'NEXT', w: when(d, true) };
  }

  function clubFeed(key){
    var c = CLUBS[key];
    function fromId(id){
      return getJSON(API + c.path + '/teams/' + id + '/schedule').then(function(j){
        var events = j.events || [];
        var out = [];
        for(var i = 0; i < events.length; i++){
          var g = readEvent(events[i], key);
          if(g) out.push(g);
        }
        log(key, 'raw', events.length, 'parsed', out.length);
        return { ok:true, games:out, raw:events.length };
      });
    }
    return fromId(c.id)
      .then(function(res){
        if(res.raw > 0) return res;
        return lookupId(c).then(function(id){
          return (id && id !== c.id) ? fromId(id) : res;
        });
      })
      .catch(function(e){ log(key, 'failed', e && e.message); return { ok:false, games:[], raw:0 }; });
  }

  function buildCurrent(sets){
    var out = [], now = Date.now(), got = false;
    CURRENT_CLUBS.forEach(function(key, i){
      var res = sets[i] || { ok:false, games:[], raw:0 };
      if(!res.ok || res.raw === 0) return;
      got = true;
      var games = res.games;
      var live = games.filter(function(g){ return g.live; });
      var played = games.filter(function(g){ return g.done; });
      var next = games.filter(function(g){ return !g.done && !g.live && g.date > now; });
      live.forEach(function(g){ out.push(g); });
      played.slice(-3).reverse().forEach(function(g){ out.push(g); });
      if(next.length) out.push(next[0]);
    });
    return got ? out : [];
  }

  function buildUpcoming(sets){
    var out = [], now = Date.now();
    UPCOMING_CLUBS.forEach(function(key, i){
      var res = sets[i] || { games:[] };
      (res.games || []).forEach(function(g){ if(!g.done && g.date > now) out.push(g); });
    });
    out.sort(function(a, b){ return a.date - b.date; });
    return out.slice(0, 16);
  }

  function init(root){
    if(!root || root.dataset.poReady) return;
    root.dataset.poReady = '1';
    DEBUG = root.dataset.debug === 'true';
    if(root.dataset.tz) TZ = root.dataset.tz;
    if(root.dataset.tzlabel) TZLABEL = root.dataset.tzlabel;
    var railA = root.querySelector('.po-rail.a');
    var railB = root.querySelector('.po-rail.b');
    paint(railA, FALLBACK_NOW);
    paint(railB, FALLBACK_NEXT);
    if(typeof fetch !== 'function' || typeof Promise === 'undefined') return;
    Promise.all(CURRENT_CLUBS.map(clubFeed))
      .then(function(sets){ var l = buildCurrent(sets); log('current', l.length); if(l.length) paint(railA, l); })
      .catch(function(e){ log('current failed', e && e.message); });
    Promise.all(UPCOMING_CLUBS.map(clubFeed))
      .then(function(sets){ var l = buildUpcoming(sets); log('upcoming', l.length); if(l.length) paint(railB, l); })
      .catch(function(e){ log('upcoming failed', e && e.message); });
  }

  function boot(){ document.querySelectorAll('.po-tickstack').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-whats-new"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.poReady) return;
    root.dataset.poReady = '1';
    var tr = root.querySelector('.po-track');
    var rail = root.querySelector('.po-prail i');
    if(!tr) return;
    function step(){ var c = tr.querySelector('.po-card'); return c ? c.offsetWidth + 18 : 260; }
    var nextBtn = root.querySelector('.po-carbtn.next');
    var prevBtn = root.querySelector('.po-carbtn.prev');
    if(nextBtn) nextBtn.addEventListener('click', function(){ tr.scrollBy({left: step()*2, behavior:'smooth'}); });
    if(prevBtn) prevBtn.addEventListener('click', function(){ tr.scrollBy({left: -step()*2, behavior:'smooth'}); });
    function prog(){
      if(!rail) return;
      var max = tr.scrollWidth - tr.clientWidth;
      var seen = tr.clientWidth / tr.scrollWidth;
      rail.style.width = Math.max(12, seen*100).toFixed(1) + '%';
      var p = max > 0 ? tr.scrollLeft / max : 0;
      rail.style.transform = 'translateX(' + (p * (100/Math.max(seen,.12) - 100)).toFixed(2) + '%)';
    }
    tr.addEventListener('scroll', prog, {passive:true});
    window.addEventListener('resize', prog);
    prog();
    var down=false, sx=0, sl=0;
    tr.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'touch') return;
      down=true; sx=e.clientX; sl=tr.scrollLeft; tr.classList.add('drag');
      try { tr.setPointerCapture(e.pointerId); } catch(err){}
    });
    tr.addEventListener('pointermove', function(e){ if(!down) return; e.preventDefault(); tr.scrollLeft = sl - (e.clientX - sx); });
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
      tr.addEventListener(ev, function(){ down=false; tr.classList.remove('drag'); });
    });
    tr.addEventListener('click', function(e){ if(Math.abs(tr.scrollLeft - sl) > 6) e.preventDefault(); }, true);
  }
  function boot(){ document.querySelectorAll('.po-newsec').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
